import { TIMEFRAMES } from "product-test-types";

export const TIMEFRAME_OPTIONS = [
  { label: "6 Periods", key: TIMEFRAMES.SIX_CYCLES },
  { label: "12 Periods", key: TIMEFRAMES.TWELVE_CYCLES },
  {
    label: "24 Periods",
    key: TIMEFRAMES.TWENTY_FOUR_CYCLES,
  },
  { label: "All Periods", key: TIMEFRAMES.ALL_CYCLES },
];

type CompletedItem = { count: number; category: string };
type CompletedItemsOverReportingCycle = Record<string, CompletedItem[]>;

export function getCompletedItemsDataAndCategories(
  completedItemsOverReportingCycle: CompletedItemsOverReportingCycle | undefined
) {
  const timeframes = [
    TIMEFRAMES.SIX_CYCLES,
    TIMEFRAMES.TWELVE_CYCLES,
    TIMEFRAMES.TWENTY_FOUR_CYCLES,
    TIMEFRAMES.ALL_CYCLES,
  ];

  const data = timeframes.map((timespan) => ({
    timespan,
    data:
      completedItemsOverReportingCycle?.[timespan]?.map((item) => item.count) ??
      [],
  }));

  const categories = timeframes.map((timespan) => ({
    timespan,
    categories:
      completedItemsOverReportingCycle?.[timespan]?.map(
        (item) => item.category
      ) ?? [],
  }));

  return { data, categories };
}
